module.exports = __webpack_public_path__ + "static/media/descrip4.37c62294.jpg";